const getStyleId = (productId: string): string => productId.substring(0, 6);

const prepareDropshipProductAttributes = (
  abbrBrand: string,
  isDropShipEnabled: boolean,
  sellerName?: string
) => ({
  product_dropship: isDropShipEnabled,
  product_seller_name:
    isDropShipEnabled && sellerName ? [sellerName] : [abbrBrand.toUpperCase()],
});

const quickAddDataBuilder = (datalayer: any): any => ({
  onQuickAddStart: (
    abbrNameForTealium: string,
    abbrBrand: string,
    categoryName: string,
    productName: string,
    productId: string,
    isDropShipEnabled: boolean,
    sellerName?: string
  ) => {
    datalayer.viewWith([
      {
        name: 'quickadd_start',
        data: {
          event_name: 'quickadd_start',
          page_name: `${abbrNameForTealium}:browse:QuickAddStart`,
          page_type: 'QuickAddStart',
          product_name: [productName],
          product_id: [getStyleId(productId)],
          product_brand: [abbrBrand.toUpperCase()],
          product_category: [categoryName],
          ...prepareDropshipProductAttributes(
            abbrBrand,
            isDropShipEnabled,
            sellerName
          ),
        },
      },
    ]);
  },
  onAddToBag: (
    abbrNameForTealium: string,
    abbrBrand: string,
    categoryName: string,
    productId: string,
    reportingData: any,
    isDropShipEnabled: boolean,
    sellerName?: string
  ) => {
    datalayer.viewWith([
      {
        name: 'cart_add',
        data: {
          ...reportingData,
          event_name: 'cart_add',
          page_name: `${abbrNameForTealium}:browse:QuickAdd`,
          page_type: 'QuickAdd',
          product_brand: [abbrBrand.toUpperCase()],
          product_category: [categoryName],
          product_id: [getStyleId(productId)],
          ...prepareDropshipProductAttributes(
            abbrBrand,
            isDropShipEnabled,
            sellerName
          ),
        },
      },
    ]);
  },
});

export { quickAddDataBuilder };
